import { Injectable } from '@angular/core';
import { QuestionBaseService } from './question-base.service';
import { UserInvitation } from '../models/clientLocation';
import { PBUser } from '../models/pb-user';
import { QuestionType, TextQuestion, NumberQuestion, BooleanQuestion } from '../models/Question';
import { Address } from '../models/Address';
import { HttpClient } from '@angular/common/http';
import { parsePhoneNumber, CountryCode, AsYouType } from 'libphonenumber-js/min';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserQuestionService extends QuestionBaseService {


  public get invitation(): UserInvitation {
    return this.user.invitation;
  }


  public set invitation(v: UserInvitation) {
    this.user.invitation = v;


  }

  public InitModel() {
    this.user.firstName = this.user.invitation.firstName;
    this.user.lastName = this.user.invitation.lastName;
    this.user.email = this.user.invitation.email;
    this.user.userName = this.user.invitation.firstName[0].toLowerCase() + this.user.invitation.lastName.toLowerCase();
    this.user.clientId = this.user.invitation.clientId;
    this.user.ecAllowed = false;
    this.user.trackingToken = this.user.invitation.inviteToken;
  }


  user: PBUser = new PBUser();

  constructor(private http: HttpClient) {
    super();
    this.saveUrl = environment.baseURl + '/api/userinvite';
    this.hasTC = true;
    this.tcVerbiage = "By clicking the button below and using ResidentIQ’s services, you acknowledge and agree that, notwithstanding its use of the ResidentIQ services, " 
    + "you are solely responsible for all recommendations and decisions regarding an applicant, and you shall not rely on the ResidentIQ services in any way when making any such recommendation or decision. " 
    + "You acknowledge that neither ResidentIQ nor any of its affiliates or vendors make any decisions or recommendations regarding an applicant. " 
    + "You further acknowledges that all information provided to you by ResidentIQ’s system regarding an applicant are based on criteria provided by you, " 
    + "and ResidentIQ has no control over such criteria or the information that ResidentIQ’s system produces as a result of such criteria. " 
    + "To the extent ResidentIQ’s system produces any information that could be construed as a recommendation or decision, you acknowledge that such information is solely attributable to your criteria and is your recommendation or decision to itself.";

    this.user.invitation = new UserInvitation();
    this.DataModel = this.user;
    // UN
    let ln = new NumberQuestion();
    ln.name = "PhoneNumber";
    ln.questionOrder = 1;
    ln.questionText = "What is your Office Phone Number?";
    ln.propertyMapping = 'phoneNumber';
    ln.validationMessage = "";
    ln.questionType = QuestionType.Text;
    ln.digits = 10;


    let mobile = new NumberQuestion();
    mobile.name = "MobilePhone";
    mobile.questionOrder = 2;
    mobile.questionText = "What is your Mobile Phone Number?";
    mobile.propertyMapping = 'mobilePhone';
    mobile.validationMessage = "";
    mobile.questionType = QuestionType.Text;
    mobile.digits = 10;

    let fax = new NumberQuestion();
    fax.name = "Fax";
    fax.questionOrder = 3;
    fax.questionText = "What is your Fax Number?";
    fax.propertyMapping = 'fax';
    fax.validationMessage = "";
    fax.questionType = QuestionType.Text;
    fax.digits = 10;

    // Allow Electronic Communications
    let ec = new BooleanQuestion();
    ec.name = "ecAllowed";
    ec.questionOrder = 4;
    ec.questionText = "Can we contact you electronically via SMS or Email?";
    ec.propertyMapping = 'ecAllowed';
    ec.validationMessage = "";
    ec.questionType = QuestionType.Boolean;

      // Allow Electronic Communications
      let title = new TextQuestion();
      title.name = "title";
      title.questionOrder = 5;
      title.questionText = "What is your title?";
      title.propertyMapping = 'title';
      title.validationMessage = "";
      title.questionType = QuestionType.Text;

    // Password
    let pass = new TextQuestion();
    pass.name = "Password";
    pass.questionOrder = 6;
    pass.questionText = "What would you like your Password to be?";
    pass.propertyMapping = 'password';
    pass.validationMessage = "";
    pass.questionType = QuestionType.Password;

    let passVerify = new TextQuestion();
    passVerify.name = "PasswordVerify";
    passVerify.questionOrder = 7;
    passVerify.questionText = "Please confirm your password?";
    passVerify.propertyMapping = 'password';
    passVerify.validationMessage = "";
    passVerify.questionType = QuestionType.Password;

    this.Questions.push(ln);
    this.Questions.push(fax);
    this.Questions.push(mobile);
    this.Questions.push(title);
    this.Questions.push(ec);
    // this.Questions.push(pass);
    // this.Questions.push(passVerify);
    this.currentQuestion = this.Questions[0];
  }

  moveNext(): boolean {
    console.log('moving in user service')
    if(this.currentQuestion.name == 'PasswordVerify'){
      this.currentQuestion.comparer = this.DataModel.password;
    }
    if (this.currentQuestion.validate() || this.currentQuestion.canFailValidation) {
      this.errorPresent = false;
      this.currentQuestion.errorOnQuestion = false;
      // then we are good and can set this property on the model.
      if (this.currentQuestion.parentPropertyName) {
        this.user[this.currentQuestion.parentPropertyName][this.currentQuestion.propertyMapping] = this.currentQuestion.answer;
      } else {
        this.user[this.currentQuestion.propertyMapping] = this.currentQuestion.answer;
      }
      // See if there is a next question to go to
      let candidates = this.Questions.filter((q) => {
        return q.questionOrder == (this.currentQuestion.questionOrder + 1);
      })
      if (candidates.length > 0) {
        this.currentQuestion = candidates[0];
        return true;
      } else {
        this.DataModel = this.user
        this.questionFlowComplete.next(true);
      }
    }
    else {
      this.errorPresent = true;
      this.currentQuestion.errorOnQuestion = true;
    }
  }

  getInvite(token: string): void {
    this.http.get(environment.baseURl + `/api/userinvite/invite/${token}`).subscribe((ev: UserInvitation) => {
      if(ev.userId){
        this.invitefetched.next({success : false, err: { error : "This invitation is no longer valid. Please contact customer service at support@residentiq.com if you need assistance logging in."}});
      }else{
        this.DataModel.invitation = ev;
        this.InitModel();
        this.invitefetched.next({success : true});
      }
    
    });
    // TODO : Error Scenario
  }
}
